import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * One pick of a Streaming section in the address (`?source=`, `?month=`, `?platform=`). A new pick
 * is a new history entry, so Back goes to the pick before (the web navigation rule). The other
 * parts of the query (the period) stay.
 */
export function useStreamingSearchParam(name: string): [string | undefined, (value: string | undefined) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get(name);
  const value = raw === null || raw === '' ? undefined : raw;

  const setValue = useCallback(
    (next: string | undefined) => {
      setSearchParams((current) => {
        const params = new URLSearchParams(current);
        if (next === undefined) {
          params.delete(name);
        } else {
          params.set(name, next);
        }
        return params;
      });
    },
    [name, setSearchParams]
  );

  return [value, setValue];
}
